<template>
  <div class="tile is-parent">
    <article class="tile is-child box">
      <p class="title">标题</p>
      <div class="block">
        <input class="input width-3" v-model="params.title">
      </div>
      <p class="title">显示状态</p>
      <div class="block">
        <input type="radio" value="1" name="setStatus" v-model="status"><label>永久开启</label>
        <input type="radio" value="0" name="setStatus" v-model="status"><label>永久关闭</label>
        <input type="radio" value="2" name="setStatus" v-model="status"><label>定时开关</label>
      </div>
      <div class="block" v-if="status == 2">
        <span class="inline-block width-2">
            <el-date-picker
                    v-model="datetimerange"
                    type="datetimerange"
                    placeholder="请选择时间">
            </el-date-picker>
        </span>
      </div>
      <p class="title">用户分群</p>
      <div class="block">
        <input type="checkbox" value="1" v-model="params.showUserStatus">未付费用户可见
        <input type="checkbox" value="2" v-model="params.showUserStatus">其他用户可见
      </div>
      <p class="title">自定义链接</p>
      <div class="block cyzs-w-400">
        <custom-link :link='params.link' @update:link="val => { params.link = val }"></custom-link>
      </div>
      <div class="block">
        <span class="button is-primary" id="js_imageUploadBtn" style="line-height: 30px;">上传图片</span>
        <span class="upload-img-tips">图片尺寸小于1M</span>
      </div>
      <div class="block">
        <image-component v-if="params.image.image" :image="params.image" :width="600"></image-component>
      </div>
      <div class="block">
        <button class="button is-primary" @click="saveEdit">保存</button>
        <button class="button" @click='backClick'>返回</button>
      </div>
    </article>
  </div>
</template>
<script type="text/babel">
import Uploader from 'COMMON/uploaderModule/uploader'
import CustomLink from 'COMMON/DefinedLink.vue'
import { formatDate } from 'UTILS/date'

export default {
  components: {
    CustomLink
  },
  data () {
    return {
      adId: 0,
      status: 1,
      params: {
        title: '',
        status: 1,
        startTime: '',
        endTime: '',
        image: {
          image: '',
          width: 0,
          height: 0
        },
        link: '',
        showUserStatus: [1, 2]
      },
      date: {},
      datetimerange: []
    }
  },
  mounted () {
    if (this.params.status == 1 && this.params.endTime > 0) { // 定时开启的
      this.params.status = 2
    } else if (this.params.status == 1) { // 永久开启的
      this.params.status = 1
    } else { // 关闭
      this.params.status = 0
    }
    this.adId = this.$route.query.adId
    if (this.adId > 0) {
      this.getAdInit()
    }
    this.uploadMainBind()
  },
  methods: {
    formatDate (date) {
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    },
    uploadMainBind () {
      // 绑定上传图片控件
      let params = {
        config: {
          pick: {
            id: '#js_imageUploadBtn',
            multiple: false
          },
          server: process.env.VUE_APP_PLATFORM + '/admin.php?method=image.uploadImage',
          fileVal: 'image',
          fileSizeLimit: 1 * 1024 * 1024,
          fileSingleSizeLimit: 1 * 1024 * 1024
        },
        extensionField: {
          target: this
        },
        events: {
          onFilesQueued (files, uploaderObj) {
            return this.onFilesQueued && this.onFilesQueued(files, uploaderObj)
          },
          onSuccess (response, file, uploaderObj) {
            this.params.image.image = response.data.images.info.path
            this.params.image.width = response.data.images.info.width
            this.params.image.height = response.data.images.info.height
          },
          onError (response, file, uploaderObj) {

          }
        }
      }
      new Uploader(params)
    },
    backClick () {
      this.$router.push({name: 'cyzsEditAd'})
    },
    // 获取详情
    getAdInit () {
      HttpRequest.get('/admin.php?method=main.getAd', { adId: this.adId }, true).then((response) => {
        if (response.data.endTime > 0 && response.data.status == 1) {
          this.status = 2
        } else {
          this.status = response.data.status
        }
        this.params = response.data
        if (!response.data.showUserStatus || response.data.showUserStatus.length == 0) {
          this.params.showUserStatus = [1, 2]
        } else {
          this.params.showUserStatus = response.data.showUserStatus
        }
        this.datetimerange.push(this.formatDate(response.data.startTime))
        this.datetimerange.push(this.formatDate(response.data.endTime))
      }, (response) => {
        this.$message('接口报错，请联系管理员')
      })
    },
    // 保存编辑
    saveEdit () {
      let params = Object.assign({}, this.params)
      params.adId = this.adId
      params.startTime = this.datetimerange[0] ? Date.parse(this.datetimerange[0]) / 1000 : ''
      params.endTime = this.datetimerange[1] ? Date.parse(this.datetimerange[1]) / 1000 : ''
      if (this.status == 2) {
        if (params.startTime <= 0) {
          this.$message('请选择开始时间')
          return
        }
        if (params.endTime <= 0) {
          this.$message('请选择结束时间')
          return
        }
      }

      if (this.status == 2) {
        params.status = 1
      } else {
        params.startTime = ''
        params.endTime = ''
        params.status = this.status
      }

      HttpRequest.post('/admin.php?method=main.doSaveAd', params, true).then((response) => {
        this.$message('编辑成功')
        if (response.data.success == 1) {
          setTimeout(() => {
            this.$router.push('/cyzsIndex/cyzsAdList')
          }, 2000)
        } else {
          this.$message('接口错误,请联系管理员')
        }
      }, (response) => {

      })
    }
  }
}
</script>
<style lang="less">
  .custom-link-wrap{
    border-radius: 6px;
    border: 1px solid #00d1b2;
    width: 300px;
    padding: 20px;
  }
  .upload-img-tips{
    position: relative;
    top: 10px;
    color: #ff0000;
  }
</style>
